export const getDataFilter = (dataFilter) => {
	if (
		dataFilter.type === '' ||
		dataFilter.operator === '' ||
		dataFilter.value === ''
	) {
		return null;
	} else
		return [
			{
				type: dataFilter.type,
				operator: dataFilter.operator,
				value: dataFilter.value,
			},
		];
};
